<template>
  <div>
    <template v-if="showHeader == true">
      <h3>{{ $t("advanced.headers." + unitName) }}</h3>
    </template>

    <v-simple-table :dense="true" :fixed-header="true">
      <template v-slot:default>
        <thead></thead>
        <tbody>
          <template v-if="filter.includes('Basic') === true">
            <!-- -->
            <AdvancedCore :name="$t('advanced.variables.SerialNumber')" :value="unitState.serialNo" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.SerialNumber')" :value="unitState.serialNumber" :widthRatio="width"></AdvancedCore>
            <tr>
              <td class="text-xs-left" :width="width + '%'">
                <b> {{ $t("advanced.variables.control") }} </b>
              </td>
            </tr>
            <AdvancedCore :name="$t('advanced.variables.version')" :value="unitState.version" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.versionBL')" :value="unitState.versionBL" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.uptime')" :value="unitState.uptimeHHMMSS" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="filter.includes('BasicSafety') === true">
            <tr>
              <td class="text-xs-left" :width="width + '%'">
                <b> {{ $t("advanced.variables.safety") }} </b>
              </td>
            </tr>
            <AdvancedCore :name="$t('advanced.variables.versionsafe')" :value="unitState.safety.version" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.versionsafe')" :value="unitState.safety.versionBL" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.uptimesafe')" :value="unitState.safety.uptimeHHMMSS" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="filter.includes('State') === true">
            <tr>
              <td class="text-xs-left" :width="width + '%'">
                <b> {{ $t("advanced.variables.control") }} </b>
              </td>
            </tr>
            <AdvancedCore :name="$t('advanced.variables.state')" :value="unitState.state" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.warning')" :value="unitState.warning" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.status')" :value="unitState.status" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.ecStatus') + ' 1'" :value="unitState.ecStatus1" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.ecStatus') + ' 2'" :value="unitState.ecStatus2" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="filter.includes('Errors') === true">
            <AdvancedCore :name="$t('advanced.variables.error1')" :value="unitState.error1" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.error2')" :value="unitState.error2" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.error3')" :value="unitState.error3" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.errors')" :value="unitState.errors" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="filter.includes('StateSafety') === true">
            <tr>
              <td class="text-xs-left" :width="width + '%'">
                <b> {{ $t("advanced.variables.safety") }} </b>
              </td>
            </tr>
            <AdvancedCore :name="$t('advanced.variables.statesafe')" :value="unitState.safety.state" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.warningsafe')" :value="unitState.safety.warning" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.statussafe')" :value="unitState.safety.status" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="filter.includes('ErrorsSafety') === true">
            <AdvancedCore :name="$t('advanced.variables.error1safe')" :value="unitState.safety.error1" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.error2safe')" :value="unitState.safety.error2" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.error3safe')" :value="unitState.safety.error3" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.variables.errorssafe')" :value="unitState.safety.errors" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="filter.includes('State') === true">
            <AdvancedCore name="" value="" :widthRatio="width"></AdvancedCore>
            <template v-if="'limitationSource' in unitState">
              <AdvancedCore :name="$t('advanced.variables.limitationSource')" :value="unitState.limitationSource" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'flashCycleCounter' in unitState">
              <AdvancedCore :name="$t('advanced.variables.flashCycleCounter')" :value="unitState.flashCycleCounter" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'limitIneg' in unitState">
              <AdvancedCore :name="$t('advanced.variables.limitIneg')" :value="unitState.limitIneg" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'limitIpos' in unitState">
              <AdvancedCore :name="$t('advanced.variables.limitIpos')" :value="unitState.limitIpos" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'limitPneg' in unitState">
              <AdvancedCore :name="$t('advanced.variables.limitPneg')" :value="unitState.limitPneg" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'limitPpos' in unitState">
              <AdvancedCore :name="$t('advanced.variables.limitPpos')" :value="unitState.limitPpos" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'totalRunTime' in unitState">
              <AdvancedCore :name="$t('advanced.variables.totalRunTime')" :value="unitState.totalRunTimeHHMMSS" :widthRatio="width"></AdvancedCore>
            </template>

            <template v-if="'bms' in unitState">
              <template v-if="'crcErrMaskDelayed' in unitState.bms">
                <AdvancedCore :name="$t('advanced.variables.crcErrMaskDelayed')" :value="unitState.bms.crcErrMaskDelayed.toString(2)" :widthRatio="width"></AdvancedCore>
              </template>

              <template v-if="'status' in unitState.bms">
                <AdvancedCore :name="$t('advanced.variables.bmsStatus')" :value="unitState.bms.status" :widthRatio="width"></AdvancedCore>
              </template>

              <template v-if="'pack' in unitState.bms">
                <AdvancedCore v-for="(item, index) in unitState.bms.pack" :key="index + 'bmsPackStatus'" :name="$t('advanced.variables.bmsPackStatus') + ' ' + (index + 1)" :value="item.status" :widthRatio="width"> </AdvancedCore>
              </template>
            </template>
          </template>
          <br />
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import AdvancedCore from "./AdvancedCore.vue";

export default {
  name: "AdvancedLogic",
  components: {
    AdvancedCore,
  },
  props: {
    unitState: {
      type: Object,
      require: false,
    },
    unitName: {
      type: String,
      require: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: Number,
      require: false,
      default: 50,
    },
    filter: {
      type: Array,
      required: false,
      default: () => ["Basic", "BasicSafety", "State", "StateSafety", "Errors", "ErrorsSafety"],
    },

    data() {
      return {};
    },
  },
  methods: {
    convertUptimeToHHMMSSFormat() {
      if ("safety" in this.unitState) {
        if ("uptime" in this.unitState.safety) {
          this.unitState.safety.uptimeHHMMSS = this.secondsToDDHHMMSS(this.unitState.safety.uptime);
          this.unitState.safety.uptimeHHMMSS = this.DDHHMMSSToString(this.unitState.safety.uptimeHHMMSS);
        }
        if ("upTime" in this.unitState.safety) {
          this.unitState.safety.uptimeHHMMSS = this.secondsToDDHHMMSS(this.unitState.safety.upTime);
          this.unitState.safety.uptimeHHMMSS = this.DDHHMMSSToString(this.unitState.safety.uptimeHHMMSS);
        }
      }
      if ("uptime" in this.unitState) {
        this.unitState.uptimeHHMMSS = this.secondsToDDHHMMSS(this.unitState.uptime);
        this.unitState.uptimeHHMMSS = this.DDHHMMSSToString(this.unitState.uptimeHHMMSS);
      }
      if ("upTime" in this.unitState) {
        this.unitState.uptimeHHMMSS = this.secondsToDDHHMMSS(this.unitState.upTime);
        this.unitState.uptimeHHMMSS = this.DDHHMMSSToString(this.unitState.uptimeHHMMSS);
      }

      if ("totalRunTime" in this.unitState) {
        this.unitState.totalRunTimeHHMMSS = this.secondsToDDHHMMSS(this.unitState.totalRunTime);
        this.unitState.totalRunTimeHHMMSS = this.DDHHMMSSToString(this.unitState.totalRunTimeHHMMSS);
      }
    },
    secondsToDDHHMMSS(secs) {
      var days = Math.floor(secs / 86400);
      var remainder = secs % 86400;

      var hours = Math.floor(remainder / 3600);
      remainder = remainder % 3600;

      var minutes = Math.floor(remainder / 60);
      var seconds = Math.ceil(remainder % 60);

      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }

      var obj = {
        d: days,
        h: hours,
        m: minutes,
        s: seconds,
      };
      return obj;
    },
    DDHHMMSSToString(object) {
      let l = "";

      if (object.d < 1) {
        return object.h + ":" + object.m + ":" + object.s;
      } else if (object.d < 2) {
        l = this.$i18n.t("advanced.variables.day");
      } else {
        l = this.$i18n.t("advanced.variables.days");
      }

      return object.d + l + object.h + ":" + object.m + ":" + object.s;
    },
  },
  watch: {
    unitState: function () {
      this.convertUptimeToHHMMSSFormat();
    },
  },
};
</script>

<style scoped></style>
